export interface UserEntity {
  authorization:  string;
  email:          string;
  emailValidated: boolean;
  id:             number;
  joinDate:       number;
  maxServer:      number;
  password:       string;
  pro:            boolean;
  proExpiryDate:  number;
  username:       string;
}

export class Convert {
  public static toUserEntity(json: any): UserEntity {
    // 如果json包含API响应结构，提取data字段
    const userData = json.data || json;

    return {
      authorization: userData.authorization,
      email: userData.email,
      emailValidated: Boolean(userData.emailValidated), // 将数字转换为boolean
      id: userData.id,
      joinDate: userData.joinDate,
      maxServer: userData.maxServer,
      password: userData.password || '', // API响应可能不包含密码字段
      pro: Boolean(userData.pro), // 将数字转换为boolean
      proExpiryDate: userData.proExpiryDate,
      username: userData.username
    };
  }

  public static userEntityToJson(value: UserEntity): string {
    return JSON.stringify(value, null, 2);
  }
}

